module.exports = __webpack_public_path__ + "img/3.2d9c9df8.png";